import { Controller } from "@hotwired/stimulus"

function toggle(button, enabled) {
  if (!button) return

  button.disabled = !enabled
  button.classList.toggle("opacity-30", !enabled)
  button.classList.toggle("cursor-not-allowed", !enabled)
}

export default class extends Controller {
  static targets = ["track", "previous", "next"]

  connect() {
    this.update()
    this.trackTarget.addEventListener("scroll", this.update)
    window.addEventListener("resize", this.update)
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  previous() {
    this.scrollByPage(-1)
  }

  next() {
    this.scrollByPage(1)
  }

  scrollByPage(direction) {
    const card = this.trackTarget.firstElementChild
    // Fall back to a viewport-sized jump when the track holds no cards to measure.
    const step = card ? card.offsetWidth + 16 : this.trackTarget.clientWidth
    this.trackTarget.scrollBy({ left: step * direction, behavior: "smooth" })
  }

  update = () => {
    const track = this.trackTarget
    // Sub-pixel widths mean the maximum scroll position is rarely reached exactly.
    const remaining = track.scrollWidth - track.clientWidth - track.scrollLeft
    toggle(this.previousTargets[0], track.scrollLeft > 1)
    toggle(this.nextTargets[0], remaining > 1)
  }
}
